<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/member-center' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>简历</el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>
    <div class="pub_main">
      <h3>个人简历</h3>
      <div class="step_box">
        <div class="step_top">
          <el-steps :active="stepActive" align-center process-status="wait" finish-status="success">
            <el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
          </el-steps>
        </div>

        <StepOne v-show="stepActive==1" @handleNextStep="handleNextStep" :info="formData" ref="one"></StepOne>
        <StepTwo v-show="stepActive==2" :info="formData" ref="two"></StepTwo>

      </div>
    </div>
  </div>
</template>

<script>
import StepOne from './publish/step-one.vue'
import StepTwo from './publish/step-two.vue'
import { formateDate } from '@/utils/date'
import { userResumeInfo,userResumeUpdate,userResumeAdd } from "@/api/user/index";

export default {
  components: {
    StepOne, StepTwo
  },
  data () {
    return {
      titleList:
      [
        {
            title:'简历信息',
        },{
            title:'发布成功',
        },
          ],
      stepActive: 1,
      resume_id:"",
      formData:  {
        resume_mobile:'',//
        resume_email:'',//
        school: '',
        native_place: '',
        resume_identity:'',//
        job_state:'',//
        is_experience:null,//
        expect_job:[],//
        expect_salary:'',
        expect_salary_day:'',
        expect_salary_week:'',
        expect_salary_month:'',
        job_log:[],//地址信息
        skill:'',//
        introduce:'',//
        resume_imgs:'',//
        resume_name:'',//
        resume_sex:'',//
        resume_age:'',//
        photoFiles:[],//
        resume_imgs	:[],
        resume_logo:'',//
        expect_address:'',
        salary_type:'',//
        status:2,//
        name:'',//
        resume_id:"",

      }
    };
  },
  created(){

    if(this.$route.query&&this.$route.query.resume_id){
      this.resume_id=this.$route.query.resume_id;
      this.initInfo();

    }
  },
  methods: {
   
    // 组件点击下一步
    handleNextStep(data) {
      this.formData=data;

        if(this.resume_id!=""&&this.resume_id!=null){
          this.updateResume();
        }else{
          this.submitResume();
        }
      
    },

    initInfo(){
      var that=this;
      userResumeInfo({resume_id:this.resume_id}).then((response) => {
        if(response.code==200){
          var info=response.data;

          Object.assign( that.formData,info)
          this.$refs.one.setParams(that.formData);

        }else{
          that.$message.error("获取信息失败");
        }
      });
    },




    submitResume(){
      var that = this;

      var params=this.formData;
      delete params.photoFiles;
      userResumeAdd(params).then((response) => {
        if(response.code==200){
          that.stepActive++
        }else{
          that.$message.error(response.msg?response.msg:"提交失败");
        }
      });
    },

    updateResume(){
      var that = this;
      var params=this.formData;
      delete params.photoFiles;
      delete params.created_at;
      userResumeUpdate(params).then((response) => {
        console.log('submitDemand',response);
        if(response.code==200){
          that.stepActive++
        }else{
          that.$message.error(response.msg?response.msg:"操作失败");

        }
      });
      
    },



  }
};
</script>

<style lang="scss" scoped>
.pub_top {
  width: 1200px;
  line-height: 20px;
  margin: 0 auto 20px;
  font-size: 14px;
}
.pub_main {
  width: 1200px;
  border-radius: 6px;
  margin: 0 auto;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  > h3 {
    font-size: 18px;
    line-height: 60px;
    padding-left: 25px;
    font-weight: bold;
    border-bottom: 1px #ccc solid;
  }
  .step_box {
    padding: 30px;
    .step_top {
      width: 700px;
      margin: 5px auto 30px;
    }
  }
}
</style>